module.exports = __webpack_public_path__ + "img/flex-pirate-ship-lg.a6907d37.svg";